import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useUser } from '../context/userContext';
import { convertCelsiusToFahrenheit, convertFahrenheitToCelsius } from '../utils/helpers';
import { Room } from '../pages/Dashboard';
import modalIcon from '../assets/modal/modal-temp.png';

interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  room: Room
  onTemperatureChange: (newTemperature: number) => void;
}


const Modal: React.FC<ModalProps> = ({ isOpen, onClose, room, onTemperatureChange }) => {
  const { unit } = useUser();
  const { t } = useTranslation();

  const unitSymbol = unit === 'Fahrenheit' ? '°F' : '°C';
  const [currentTemperature, setCurrentTemperature] = useState(
    unit === 'Fahrenheit' ? convertCelsiusToFahrenheit(room.temperature as number) : room.temperature
  );

  if (!isOpen) return null;

  const handleTemperatureChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setCurrentTemperature(Number(e.target.value));
  };

  const handleSave = () => {
    let temperatureToSave = currentTemperature;

    // Convert back to Celsius if unit is Fahrenheit
    if (unit === 'Fahrenheit') {
      temperatureToSave = convertFahrenheitToCelsius(currentTemperature as number);
    }

    onTemperatureChange(temperatureToSave as number);
  };

  return (
    <div className="modalOverlay" onClick={onClose}>
      <div className="modalContent" onClick={(e) => e.stopPropagation()}>
        <img src={modalIcon} width={48} height={48} />
        <h2>{room.name}</h2>
        <label>
          {t('setTemperature')}
        </label>
        <input
          type="number"
          value={currentTemperature}
          onChange={handleTemperatureChange}
          step="0.1"
          min={16}
          max={35}
        />
        <span className="unitSymbol">{unitSymbol}</span>
        <div className="modalButtons">
          <button className='backButton' onClick={onClose}>{t('back')}</button>
          <button className='saveButton' onClick={handleSave}>{t('save')}</button>
        </div>
      </div>
    </div>
  );
};

export default Modal;
